/**
 * Resolves after `delayInMS` delay.
 * 
 * @param {Number} delayInMS delay in milliseconds
 */
export default function timeoutAsPromise(delayInMS = 0) {
    return new Promise(resolve => {
        setTimeout(resolve, delayInMS);
    });
}